export default __webpack_public_path__ + "static/media/loveseat-1-seat-2-back.9d332cd0.webp";